export class DtoConfiguracionLogin {
    verUsuario: boolean;
    verContrasenia: boolean;
    verCompania: boolean;
    verIngresar: boolean;
    verIngresarAzureAD: boolean;
    verModificarContrasenia: boolean;
    verOlvidasteContrasenia: boolean;
}